import { WSList } from "@wingspanhq/fe-component-library";
import React from "react";
import { IFormChecklistItem } from "../types";
import { ChecklistItem } from "./ChecklistItem";
import { ChecklistLockedItem } from "./ChecklistLockedItem";

type Props = {
  items: IFormChecklistItem[];
  /** When set, each form returns here after submit (requirement page). */
  backPath?: string;
};

/**
 * The ordered checklist rows shared by both tax-form checklists: forms still
 * blocked by a prerequisite render as locked rows, the rest as actionable rows.
 */
export const ChecklistRows: React.FC<Props> = ({ items, backPath }) => (
  <WSList gap="M">
    {items.map(item =>
      item.blockedBy.length > 0 ? (
        <ChecklistLockedItem key={item.id} item={item} allItems={items} />
      ) : (
        <ChecklistItem key={item.id} item={item} backPath={backPath} />
      )
    )}
  </WSList>
);
